import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {IcdCodeService} from "../services/icd-code.service";

@Component({
  selector: 'app-icd-code-list',
  templateUrl: './icd-code-list.component.html',
  styleUrl: './icd-code-list.component.scss'
})
export class IcdCodeListComponent implements OnInit, OnChanges   {
  @Input() medicalRecords: any[] = [];
  @Output() medicalRecordItemsChange = new EventEmitter<any[]>();

  newMedicalRecordItem: boolean = false;
  newMedicalRecordData: any = {
    icdCodeId: '',
    icdCodeName: '',
    icdCode: '',
    description: '',
  }
  medicalRecordItems: Array<any> = [];
  isEditing: any;
  icdCodeList: any[] = [];

  private icdLoaded = false;
  constructor(
    private readonly icdCodeService: IcdCodeService,
    ) {
  }


  loadIcdCodes() {
    if (this.icdLoaded) return;

    this.icdCodeService.getList().subscribe((res: any[]) => {
      this.icdCodeList = (res ?? []).map((icd: any) => ({
        value: icd,
        label: `${icd.code} - ${icd.name}`,
      }));

      this.icdLoaded = true;
    });
  }

  ngOnInit(): void {
    this.icdCodeService.getList().subscribe(
      res => {
        this.icdCodeList = res.map((icd: any) => ({
          value: icd,
          label: `${icd.code} - ${icd.name}`,
        }));
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["medicalRecords"]?.currentValue) {
      this.medicalRecordItems = changes["medicalRecords"].currentValue;
    }
  }

  
  newHeadItem() {
    this.newMedicalRecordItem = !this.newMedicalRecordItem;

    if (this.newMedicalRecordItem) {
      this.loadIcdCodes();
    }

    this.newMedicalRecordData = {
      icdCodeId: '',
      icdCodeName: '',
      icdCode: '',
      description: '',
    };
  }

  onIcdCodeSelect(event: any) {
    const selectedIcdCode = this.icdCodeList.find((item) => item.value === event.value);
    if (selectedIcdCode) {
      const { id, name, code } = selectedIcdCode.value; // Corrected access
      this.newMedicalRecordData.icdCodeId = id;
      this.newMedicalRecordData.icdCodeName = name;
      this.newMedicalRecordData.icdCode = code;
    }
  }

  addMedicalRecord(newMedicalRecordData: any): void {
    if (!newMedicalRecordData.icdCodeId && !newMedicalRecordData.description) {
      console.error('En az biri doldurulmalıdır.');
      return;
    }
    this.newMedicalRecordData = {
      icdCodeId: '',
      icdCodeName: '',
      icdCode: '',
      description: '',
    }

    const newMedicalRecord = {
      icdCodeId: newMedicalRecordData.icdCodeId, // Keep the ID
      icdCodeName: newMedicalRecordData.icdCodeName,
      icdCode: newMedicalRecordData.icdCode,
      description: newMedicalRecordData.description,
      id: Date.now(),
      seleceted: newMedicalRecordData
    };
    this.medicalRecordItems.push(newMedicalRecord);

    console.log('eklenen medikal kayıt:', newMedicalRecordData);

    const medicalRecordDataToEmit = this.medicalRecordItems.map(medicalRecord => {
      const { id, ...rest } = medicalRecord;
      return rest;
    });

    this.medicalRecordItemsChange.emit(medicalRecordDataToEmit);
  }

  deleteItem(index: number): void {
    this.medicalRecordItems.splice(index, 1);
    this.medicalRecordItemsChange.emit(this.medicalRecordItems);
  }

  saveItem(item: any) {
    if (!item.icdCodeId && !item.description) {
      console.error('En az biri doldurulmalıdır.');
      return;
    }
    const index = this.medicalRecordItems.findIndex(i => i.id === item.id);

    if (index !== -1) {

      this.medicalRecordItems[index] = {...item};
      this.medicalRecordItemsChange.emit(this.medicalRecordItems);
    }

    this.isEditing = null;
  }

}
